import colors from 'lib/constants/resourceColors';
import React from 'react';
import moment from 'moment';
import AccessRulesConfig from 'components/AccessRulesConfig';
import UserHomeAddress from 'components/UserHomeAddress';
import Privileges from 'lib/constants/privileges';
import renderCondition from 'lib/helpers/renderCondition';
import api from 'api';


const userForm = [
    {key: 'first_name'},

    {key: 'last_name'},

    {key: 'title'},

    // users.classification, an FK to rate_types.code. It sets which contract rate a user bills
    // at, and NULL keeps them out of the work order technician picker.
    {key: 'classification',
        label: 'User Type',
        type: 'options',
        showInCreateMode: false,
        optionsURL: '/enums/rate_types',
        optionsFilter: (rateType) => rateType.category === 'labor' && rateType.active,
        optionsMapper: (rateType) => ({value: rateType.code, label: rateType.name}),
        emptyOptionLabel: 'Undefined'},

    {type: 'date', 
        key:'start_date'},

    {type: 'date', 
        key:'end_date', 
        showEmpty: false},

    '~profileImage(Profile Photo){avatar_url}',

    {key: 'phone', label: 'Phone Number'},

    {key: 'email', required: true},

    {key: 'password', 
        requiredOnCreate: true, 
        label: 'New Password', 
        writeOnly: true, 
        nullable: false},

    {key: 'roles',
        type: 'relations',
        label: 'Roles',
        placeholder: 'Assign a New Role...',
        submitLabel: 'Assign',
        addRelation: (roleId, user) => api.upsert(`/user_roles/users/${user.id}/roles/${roleId}`),
        deleteRelation: (roleId, user) => api.destroy(`/user_roles/users/${user.id}/roles/${roleId}`),
        optionsUrl: (user) => '/roles',
        optionTransform: (option) => { return {value: option.id, label: option.name} } , 
        getRelations: (user) => user.roles,
        relationTransform: (r, index) => { return {key:`${index}_${r.id}`, value: r.id, label: r.name} },
    },

];

export default {
    defaults: {
        name: 'User',
        color: colors.user,
        formFields: userForm,
    },

    view: {
        title: (u) => `${u.first_name} ${u.last_name}`,
        extraRender: (props) => {
            return <React.Fragment>
                {renderCondition([Privileges.VIEW_USER_HOME_ADDRESSES],
                    <UserHomeAddress key={props.match.params.id} user_id={props.match.params.id} />)}
                <AccessRulesConfig user_id={props.match.params.id} />
            </React.Fragment>
        }
    },

    search: {
        fields: ['id','first_name','last_name', 'avatar_url', 'end_date'],
        // Users are never deleted -- they are retired by setting an End Date -- so the default
        // view is the people who still work here. `employed` is the users resource's existing
        // query param (est-back-end/resources/users.js), a `not_expired` test on end_date:
        // true -> end_date in the future or NULL, false -> end_date already passed.
        filterOptions: [
            {label: 'Active', filters: {employed: true}},
            {label: 'Terminated', filters: {employed: false}},
            {label: 'All', filters: {}},
        ],
        dataTransform: (user) => Object.assign(user, {avatar_url: user.avatar_url, full_name: [user.first_name, user.last_name].filter(v => v).join(' ')}),
        links: ['new'],
        tableProps: {
            rowURL: '/users/:id',
            keyFunc: (item, index) => `${item.first_name}_${item.last_name}_${index}`,
            columns: [
                {heading: 'Image', cellWidth: '45px', imageWidth: '45px', type: 'image', accessor: 'avatar_url'}, 
                {heading: 'Name', type: 'multiple', rows: [
                {heading: 'Name', accessor: 'full_name', placeholder: 'No Name'},
                // Only rendered for retired users, so the Terminated/All views say who is gone
                // and since when instead of looking identical to the Active view.
                {heading: 'Terminated', valueFunc: (user) => user.end_date
                    ? <span style={{display: 'block', fontStyle: 'italic', fontSize: '12px', color: '#a8071a'}}>
                          {`Terminated ${moment(user.end_date).format('MMM DD, YYYY')}`}
                      </span>
                    : null},
            ]}],

            showHeading: false,
        }
    },
    
};
